export default __webpack_public_path__ + "static/media/apps_white.2aa687f0.svg";